export const PERSPECTIVE_REVIEW_STAGES = [
    {
        id: 'pending',
        status: 'Human review pending',
        explanation: 'No community or graduate-level human review has been recorded.',
    },
    {
        id: 'community-reviewed',
        status: 'Community reviewed',
        explanation: 'Community members or internal reviewers may have informally reviewed the page and provided feedback. This does not imply graduate-level editing or citation verification.',
    },
    {
        id: 'graduate-ai-revision',
        status: 'Graduate-guided AI revision',
        explanation: 'A graduate-level reviewer has assessed the page and directed AI to add or revise perspectives; the resulting material still needs manual review and citation checking.',
    },
    {
        id: 'graduate-citations-checked',
        status: 'Graduate-reviewed · text and citations checked',
        explanation: 'A graduate-level reviewer has manually reviewed or edited the text and checked the citations against the claims.',
    },
    {
        id: 'expert-reviewed',
        status: 'Expert-reviewed · text and citations checked',
        explanation: 'A subject-matter expert has reviewed the text and checked the citations against the claims.',
    },
];

export const getPerspectiveReviewStage = (status) => PERSPECTIVE_REVIEW_STAGES.find((stage) => stage.status === status) || PERSPECTIVE_REVIEW_STAGES[0];
